module.exports = __webpack_public_path__ + "img/iphone-charging-FRANCE-fr.2df4ae35.png";